import HeaderCarousel from "@/components/HeaderCarousel";
import { Reveal } from "@/components/Reveal";
import { SITE, PAGE_HEADERS } from "@/data/site";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";

export default function Contact() {
  // Google Maps Embed URL for your address
  const mapUrl = "https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d3983.562799166106!2d101.71644072447047!3d3.2088512027837814!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sG-6%2C%20Pangsapuri%20Suite%20Danau%20Kota%20No.%201%2C%20Jln%206a%2F6%2C%20Jln%20Tmn%20Ibu%20Kota%2C%20Taman%20Danau%20Kota%2C%2053300%20Kuala%20Lumpur!5e0!3m2!1sen!2smy!4v1786928367899!5m2!1sen!2smy";

  return (
    <div data-testid="contact-page">
      <HeaderCarousel testid="contact-header" {...PAGE_HEADERS.contact} />

      <section className="max-w-7xl mx-auto px-6 md:px-12 pt-20 md:pt-28 pb-24">
        {/* Contact Details Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {/* Email — hero block */}
          <Reveal className="lg:col-span-7">
            <a
              href={`mailto:${SITE.email}`}
              data-testid="contact-email"
              className="group block rounded-[2rem] bg-michma text-white p-10 md:p-14 h-full hover:bg-michma-hover transition-colors duration-300"
            >
              <div className="flex items-center gap-3 text-white/70">
                <Mail className="w-5 h-5" />
                <span className="font-mono text-xs uppercase tracking-[0.2em]">Email us</span>
              </div>
              <p className="mt-8 font-heading font-extrabold text-3xl md:text-5xl tracking-tighter break-words">
                {SITE.email}
              </p>
              <span className="inline-flex items-center gap-1 mt-8 font-semibold">
                Write to us <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </span>
            </a>
          </Reveal>

          {/* Phone + Address column */}
          <div className="lg:col-span-5 grid grid-rows-2 gap-6">
            <Reveal>
              <a
                href={`tel:${SITE.phone.replace(/[^+\d]/g, "")}`}
                data-testid="contact-phone"
                className="group block rounded-[2rem] border border-slate-200 p-10 h-full hover:border-michma transition-colors duration-300"
              >
                <div className="flex items-center gap-3 text-michma">
                  <Phone className="w-5 h-5" />
                  <span className="font-mono text-xs uppercase tracking-[0.2em]">Call us</span>
                </div>
                <p className="mt-6 font-heading font-bold text-2xl md:text-3xl tracking-tight text-michma-ink">
                  {SITE.phone}
                </p>
              </a>
            </Reveal>

            <Reveal delay={0.08}>
              <div data-testid="contact-address" className="rounded-[2rem] border border-slate-200 p-10 h-full">
                <div className="flex items-center gap-3 text-michma">
                  <MapPin className="w-5 h-5" />
                  <span className="font-mono text-xs uppercase tracking-[0.2em]">Visit us</span>
                </div>
                <address className="mt-6 not-italic text-lg leading-relaxed text-michma-ink">
                  {SITE.address.map((line) => (
                    <span key={line} className="block">{line}</span>
                  ))}
                </address>
              </div>
            </Reveal>
          </div>
        </div>

        {/* New Map Section */}
        <Reveal delay={0.15}>
          <div className="mt-6 w-full h-[400px] rounded-[2rem] overflow-hidden border border-slate-200 shadow-sm">
            <iframe
              src={mapUrl}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Michma Location Map"
            ></iframe>
          </div>
        </Reveal>

        {/* Socials */}
        <Reveal delay={0.2}>
          <div className="mt-6 rounded-[2rem] bg-michma-soft border border-slate-100 p-10 md:p-14 flex flex-col md:flex-row md:items-center justify-between gap-8">
            <div>
              <p className="font-mono text-xs uppercase tracking-[0.2em] text-michma mb-3">Follow the movement</p>
              <h2 className="font-heading font-bold text-3xl tracking-tight text-michma-ink">Stay connected with Michma.</h2>
            </div>
            <div className="flex flex-wrap gap-3">
              {SITE.socials.map((s) => (
                <a
                  key={s.label}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 rounded-full border border-michma text-michma px-6 py-3 font-semibold hover:bg-white transition-colors duration-300"
                >
                  {s.label} <ArrowUpRight className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>
        </Reveal>
      </section>
    </div>
  );
}